import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'
import VueSuperagent from 'vue-superagent'

Vue.use(Vuex)
Vue.use(VueSuperagent, {
  baseUrl: '/api'
})

const defaultAccount = {
  id: null,
  login: '',
  display_name: '',
  is_admin: false,
  roles: []
};

export default new Vuex.Store({
  state: {
    app: {
      loadingCount: 0,
      checkingSession: false,
      categories: [],
      account: {
        id : null,
        login : '',
        display_name : '',
        is_admin : false,
        roles: []
      },
    }
  },
  mutations: {
    accountLogin(state, account) {
      state.app.account = account;
    },
    accountLogout(state) {
      state.app.account = defaultAccount;
    },
  },
  actions: {
    checkSession({ state, commit }) {
      if (state.app.checkingSession) {
        return;
      }
      state.app.loadingCount++;
      state.app.checkingSession = true;
      Vue.superagent
        .get('/account/session')
        .then((res) => {
          commit('accountLogin', res.body.session);
        })
        .catch(() => {
          // silently ignore
        })
        .then(() => {
          state.app.loadingCount--;
          state.app.checkingSession = false;
        });
    },
    fetchCategories({ state }) {
      state.app.loadingCount++
      Vue.superagent
        .get('/categories')
        .then(res => {
          state.app.categories = res.body.categories
        })
        .catch(err => {
          alert('Failed to fetch categories')
        })
        .then(() => {
          state.app.loadingCount--
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js